<div class="flex justify-content-center h-screen">
  <div class="align-content-center">
    <p-progressSpinner
      strokeWidth="3"
      styleClass="w-6rem h-6rem"
    ></p-progressSpinner>
  </div>
</div>
